import dayjs from "dayjs"

function join(t: number | Date | undefined, a: any, s: any) {
    function format(m: any) {
        let f = new Intl.DateTimeFormat("en", m)
        return f.format(t)
    }
    return a.map(format).join(s)
}

let a = [{ day: "numeric" }, { month: "short" }, { year: "numeric" }]

export function prettyDate(d: any, includeTime = false) {
    const delta = Math.round((+new Date() - d) / 1000)
    const minute = 60,
        hour = minute * 60,
        day = hour * 24,
        week = day * 7

    let fuzzy

    if (delta < 30) {
        fuzzy = "just now"
    } else if (delta < 2 * minute) {
        fuzzy = "a minute ago"
    } else if (delta < 20 * minute) {
        fuzzy = Math.floor(delta / minute) + " minutes ago"
    } else if (delta < hour) {
        fuzzy = Math.floor(delta / (10 * minute)) * 10 + " minutes ago"
    } else if (Math.floor(delta / hour) == 1) {
        fuzzy = "1 hour ago"
    } else if (delta < day) {
        fuzzy = Math.floor(delta / hour) + " hours ago"
    } else if (delta < day * 2) {
        fuzzy = "yesterday"
    } else if (delta < week) {
        fuzzy = Math.floor(delta / day) + " days ago"
    } else {
        if (includeTime) {
            fuzzy = dayjs(d).format("DD MMM HH:mm")
        } else {
            fuzzy = join(d, a, " ")
        }
    }

    return fuzzy
}

const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
]
const monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
export const dateToMonth = (d: any) => monthNamesShort[d.getMonth()]
export const dateToMonthYear = (d: any) => `${dateToMonth(d)} ${d.getFullYear()}`

export const dateIsLessThanSecondsAgo = (d: any, seconds: number) => {
    return (new Date().getTime() - d.getTime()) / 1000 < seconds
}
